import ServiceHeader from "../../ServiceComponents/ServiceHeader";

export default function ContactBGSection() {
    return (
        <>
            <ServiceHeader
                childClass="contactBgSections"
                breadcrumb={<> Contacts</>}
                title="Contacts"
            />
        </>
    )
}